import { Box, Button, FormControlLabel, Stack, Typography } from "@mui/material"
import { useContext, useState } from "react"
import { CheckoutContext } from "../../../../core/contexts/CheckoutContext"
import BpCheckbox from "../../../Inputs/BpCheckbox"

const CheckoutButtonCommit6 = () => {
  const { sendingPurchase, isPurposeCardUpdate } = useContext(CheckoutContext)
  const [saveInfo, setSaveInfo] = useState(true)

  const textButton = isPurposeCardUpdate()
    ? "Atualizar dados do cartão"
    : "Finalizar compra"

  return (
    <Stack
      direction={"column"}
      alignContent={"center"}
      alignItems={"center"}
      sx={{ width: "100%", pt: 2 }}
    >
      <Button
        fullWidth
        disableElevation
        id="buttonCommit"
        type="submit"
        variant="contained"
        disabled={sendingPurchase}
        style={{
          height: 70,
          textTransform: "none",
          border: "0px solid black",
          color: "white",
          backgroundColor: sendingPurchase ? "#85868A" : "#34c759",
        }}
        //sx={{ fontWeight: 700, fontSize: "22px", lineHeight: "32px" }}
        data-testid="buttonCommit"
      >
        <Typography fontWeight={500} fontSize="22px" lineHeight="28px">
          {textButton}
        </Typography>
      </Button>

      <Box width="100%" sx={{ mt: 0.5 }}>
        <FormControlLabel
          control={
            <BpCheckbox
              checked={saveInfo}
              onChange={(e) => setSaveInfo(e.target.checked)}
            />
          }
          label={
            <Typography
              lineHeight="18px"
              fontSize="14px"
              color="#5D5E61"
              fontWeight={600}
            >
              Salvar minhas informações com segurança para compras futuras
            </Typography>
          }
        />
      </Box>

      <Box sx={{ marginTop: 3, marginBottom: 1 }}>
        <img
          src="/assets/layouts/v6/logo-celetus-grey-footer.svg"
          alt="celetus"
        />
      </Box>
    </Stack>
  )
}

export default CheckoutButtonCommit6
